import React from "react";

export const LabelValor = ({ label, valor, style }) => {
  return (
    <div
      style={{...style}}
    >
      <div className="inputLabel">{label}</div>
      <div className="valor">{valor}</div>
    </div>
  );
};
